import Container from '../components/ui/container'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['hero'][0], { blockType: 'large-hero-image' }>

export default function LargeHeroImage(block: BlockProps): ReactElement {
  const { image, options } = block
  const className = options?.className
  const variant = options?.variant ?? 'default'

  return (
    <Container>
      <div className="group w-full relative mt-8 mb-4 min-h-[600px] min-w-full overflow-hidden">
        {variant === 'default' ? (
          <>
            <div className="z-10 absolute inset-0 bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light" />
            <Asset
              resource={image as AssetType}
              fill
              imgClassName={`object-cover object-center group-hover:scale-105 bg-black transition-transform duration-1000 ${className}`}
            />
          </>
        ) : (
          <Asset
            resource={image as AssetType}
            width={1920}
            height={400}
            imgClassName={`object-contain object-center group-hover:scale-105 transition-transform duration-1000 ${className}`}
          />
        )}
      </div>
    </Container>
  )
}
